// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-stats-widget {
  z-index: 2;
}
.task-stats-widget .widget-header {
  font-size: 1.4rem;
  margin-bottom: 20px;
}
.task-stats-widget .widget-header .widget-title {
  font-size: 1.25rem;
  margin-bottom: 1.5rempx;
  font-weight: 600;
  color: #1e293b;
  text-align: center;
}
.task-stats-widget .widget-header .tab-container {
  display: flex;
  background: #f1f5f9;
  border-radius: 6px;
  padding: 2px;
  gap: 2px;
}
.task-stats-widget .widget-header .tab-container .tab-button {
  padding: 12px 8px;
  width: 50%;
  border: none;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  background: transparent;
  color: #64748b;
  transition: all 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.task-stats-widget .widget-header .tab-container .tab-button:hover {
  background: #e2e8f0;
}
.task-stats-widget .widget-header .tab-container .tab-button.active {
  border-bottom: 3px solid #475569;
}
.task-stats-widget .widget-content .chart-container {
  border-radius: 6px;
  padding: 12px;
  text-align: center;
}
.task-stats-widget .widget-content .chart-container .chart-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}
.task-stats-widget .widget-content .chart-container .total-tasks {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(79, 70, 229, 0.1);
  padding: 4px 12px;
  border-radius: 12px;
  margin-bottom: 8px;
}
.task-stats-widget .widget-content .chart-container .total-tasks .total-label {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}
.task-stats-widget .widget-content .chart-container .total-tasks .total-number {
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-color);
}
.task-stats-widget .widget-content .no-data {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
  background: #f8fafc;
  border-radius: 6px;
}
.task-stats-widget .widget-content .no-data .no-data-icon {
  font-size: 24px;
  margin-bottom: 8px;
  opacity: 0.6;
}
.task-stats-widget .widget-content .no-data p {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
}

.stat-tooltip-label {
  color: white;
  padding: 0.5rem 0.75rem;
  background-color: #1e293b;
}

@media (max-width: 480px) {
  .task-stats-widget {
    max-width: 280px;
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TaskStatsWidget/TaskStatsWidget.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AAAE;EACE,iBAAA;EACA,mBAAA;AAEJ;AAAI;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAEN;AACI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;AACN;AACM;EAEE,iBAAA;EACA,UAAA;EACA,YAAA;EAEA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AADR;AAGQ;EACE,mBAAA;AADV;AAIQ;EACE,gCAAA;AAFV;AAWI;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;AATN;AAWM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AATR;AAYM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAVR;AAYQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAVV;AAaQ;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;AAXV;AAgBI;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAdN;AAgBM;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AAdR;AAiBM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAfR;;AAqBA;EACE,YAAA;EACA,uBAAA;EACA,yBAAA;AAlBF;;AAsBA;EACE;IACE,gBAAA;IACA,aAAA;EAnBF;AACF","sourcesContent":[".task-stats-widget {\r\n  z-index: 2;\r\n  .widget-header {\r\n    font-size: 1.4rem;\r\n    margin-bottom: 20px;\r\n\r\n    .widget-title {\r\n      font-size: 1.25rem;\r\n      margin-bottom: 1.5rempx;\r\n      font-weight: 600;\r\n      color: #1e293b;\r\n      text-align: center;\r\n    }\r\n\r\n    .tab-container {\r\n      display: flex;\r\n      background: #f1f5f9;\r\n      border-radius: 6px;\r\n      padding: 2px;\r\n      gap: 2px;\r\n\r\n      .tab-button {\r\n        // flex: 1;\r\n        padding: 12px 8px;\r\n        width: 50%;\r\n        border: none;\r\n        // border-radius: 4px;\r\n        font-weight: 500;\r\n        font-size: 14px;\r\n        cursor: pointer;\r\n        background: transparent;\r\n        color: #64748b;\r\n        transition: all 0.2s;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: 5px;\r\n\r\n        &:hover {\r\n          background: #e2e8f0;\r\n        }\r\n\r\n        &.active {\r\n          border-bottom: 3px solid #475569;\r\n        //   color: #64748b;\r\n        //   box-shadow: 0 2px 8px rgba(51, 65, 85, 0.3);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .widget-content {\r\n    .chart-container {\r\n      border-radius: 6px;\r\n      padding: 12px;\r\n      text-align: center;\r\n\r\n      .chart-title {\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        color: #1e293b;\r\n        margin: 0 0 8px 0;\r\n      }\r\n\r\n      .total-tasks {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 4px;\r\n        background: rgba(79, 70, 229, 0.1);\r\n        padding: 4px 12px;\r\n        border-radius: 12px;\r\n        margin-bottom: 8px;\r\n\r\n        .total-label {\r\n          font-size: 12px;\r\n          font-weight: 500;\r\n          color: #64748b;\r\n        }\r\n\r\n        .total-number {\r\n          font-size: 14px;\r\n          font-weight: 600;\r\n          color: var(--primary-color);\r\n        }\r\n      }\r\n    }\r\n\r\n    .no-data {\r\n      text-align: center;\r\n      padding: 20px;\r\n      color: #94a3b8;\r\n      background: #f8fafc;\r\n      border-radius: 6px;\r\n\r\n      .no-data-icon {\r\n        font-size: 24px;\r\n        margin-bottom: 8px;\r\n        opacity: 0.6;\r\n      }\r\n\r\n      p {\r\n        margin: 0;\r\n        font-size: 12px;\r\n        font-weight: 500;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.stat-tooltip-label {\r\n  color: white;\r\n  padding: 0.5rem 0.75rem;\r\n  background-color: #1e293b;\r\n}\r\n\r\n// Mobile\r\n@media (max-width: 480px) {\r\n  .task-stats-widget {\r\n    max-width: 280px;\r\n    padding: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
